import { gql } from "@apollo/client";

// ==========================================
// ANALYTICS - QUERIES
// ==========================================

export const GET_ANALYTICS_OVERVIEW = gql`
  query GetAnalyticsOverview($filters: AnalyticsFilters) {
    analyticsOverview(filters: $filters) {
      totalPageViews
      uniqueVisitors
      totalSessions
      bounceRate
      avgSessionDuration
      avgPagesPerSession
      totalEvents
    }
  }
`;

export const GET_ANALYTICS_TIME_SERIES = gql`
  query GetAnalyticsTimeSeries($filters: AnalyticsFilters) {
    analyticsTimeSeries(filters: $filters) {
      date
      pageViews
      visitors
      sessions
    }
  }
`;

export const GET_TRAFFIC_SOURCES = gql`
  query GetTrafficSources($filters: AnalyticsFilters) {
    trafficSources(filters: $filters) {
      source
      sessions
      pageViews
      bounceRate
      avgSessionDuration
      percentage
    }
  }
`;

export const GET_DEVICE_STATS = gql`
  query GetDeviceStats($filters: AnalyticsFilters) {
    deviceStats(filters: $filters) {
      deviceType
      sessions
      percentage
    }
  }
`;

export const GET_TOP_PAGES = gql`
  query GetTopPages($filters: AnalyticsFilters) {
    topPages(filters: $filters) {
      pagePath
      pageTitle
      views
      uniqueVisitors
      avgTimeOnPage
      avgScrollDepth
      bounceRate
    }
  }
`;

export const GET_CALCULATOR_STATS = gql`
  query GetCalculatorStatsByType($filters: AnalyticsFilters) {
    calculatorStatsByType(filters: $filters) {
      calculatorName
      calculatorType
      submissions
      conversionRate
      leadCaptureRate
      leadsCaputured
    }
  }
`;

export const GET_REALTIME_STATS = gql`
  query GetRealTimeStats {
    realTimeStats {
      activeVisitors
      activePages
      pageViewsLastHour
      eventsLastHour
    }
  }
`;

// ==========================================
// ANALYTICS - TRACKING MUTATIONS (PUBLIC)
// ==========================================

export const TRACK_PAGE_VIEW = gql`
  mutation TrackPageView($input: TrackPageViewInput!) {
    trackPageView(input: $input) {
      id
    }
  }
`;

export const UPDATE_PAGE_VIEW = gql`
  mutation UpdatePageView($input: UpdatePageViewInput!) {
    updatePageView(input: $input) {
      id
    }
  }
`;

export const TRACK_EVENT = gql`
  mutation TrackEvent($input: TrackEventInput!) {
    trackEvent(input: $input) {
      id
    }
  }
`;

// ==========================================
// ANALYTICS NOTIFICATION RULES
// ==========================================

export const GET_ANALYTICS_NOTIFICATION_RULES = gql`
  query GetAnalyticsNotificationRules {
    analyticsNotificationRules {
      id
      name
      trigger
      recipientType
      recipientIds
      recipientTag
      channels
      timing
      timingMinutes
      thresholdValue
      thresholdPath
      isEnabled
      messageTemplate
      createdAt
    }
  }
`;

export const CREATE_ANALYTICS_NOTIFICATION_RULE = gql`
  mutation CreateAnalyticsNotificationRule($input: CreateAnalyticsNotificationRuleInput!) {
    createAnalyticsNotificationRule(input: $input) {
      id
      name
      trigger
      recipientType
      channels
      isEnabled
    }
  }
`;

export const UPDATE_ANALYTICS_NOTIFICATION_RULE = gql`
  mutation UpdateAnalyticsNotificationRule($input: UpdateAnalyticsNotificationRuleInput!) {
    updateAnalyticsNotificationRule(input: $input) {
      id
      name
      trigger
      recipientType
      recipientIds
      recipientTag
      channels
      timing
      timingMinutes
      thresholdValue
      thresholdPath
      isEnabled
      messageTemplate
    }
  }
`;

export const DELETE_ANALYTICS_NOTIFICATION_RULE = gql`
  mutation DeleteAnalyticsNotificationRule($id: ID!) {
    deleteAnalyticsNotificationRule(id: $id)
  }
`;

export const TOGGLE_ANALYTICS_NOTIFICATION_RULE = gql`
  mutation ToggleAnalyticsNotificationRule($id: ID!) {
    toggleAnalyticsNotificationRule(id: $id) {
      id
      isEnabled
    }
  }
`;

// Shared — used by the NotificationSettings recipient picker
export const GET_EMPLOYEES_FOR_ANALYTICS_NOTIFICATIONS = gql`
  query GetEmployeesForAnalyticsNotifications {
    employees {
      id
      workEmail
      client {
        id
        fName
        lName
      }
    }
  }
`;

export const GET_CLIENTS_FOR_ANALYTICS_NOTIFICATIONS = gql`
  query GetClientsForAnalyticsNotifications {
    clients {
      id
      fName
      lName
      email
      phoneNumber
    }
  }
`;
